import { render } from "./ReportLoginLog.vue?vue&type=template&id=72f9adae"
import script from "./ReportLoginLog.vue?vue&type=script&lang=js"
export * from "./ReportLoginLog.vue?vue&type=script&lang=js"
script.render = render

export default script